import request from '@/utils/request'

// 获取线索列表
export function getLeadList(data) {
  return request({
    url: '/move/getLeadsInfo',
    method: 'post',
    data
  })
}

// 获取线索详情
export function getLeadDetail(id) {
  return request({
    url: `/lead/${id}`,
    method: 'get'
  })
}

// 新增线索
export function addLead(data) {
  return request({
    url: '/move/addLeads',
    method: 'post',
    data
  })
}

// 更新线索
export function updateLead(data) {
  return request({
    url: `/move/editLeads`,
    method: 'post',
    data
  })
}

// 删除线索
export function deleteLead(id) {
  return request({
    url: `/move/${id}`,
    method: 'delete'
  })
}

// 转换线索为客户
export function convertLead(params) {
  return request({
    url: `/move/changeLeads`,
    method: 'get',
    params: params
  })
}

// 分配线索
export function assignLead(id, data) {
  return request({
    url: `/lead/${id}/assign`,
    method: 'post',
    data
  })
} 